<template>
  <!-- container -->
  <div id="middleWrapM" class="container">
    <!-- sub title -->
    <div :class="['sub_tit_area', isPC ? 'area_white' : 'recruit04']">
      <div class="tit_area">
        <div class="sub_tit">채용안내</div>
        <div class="sub_txt">
          한국오션플랫폼과 함께 도전하고<br />새로운 미래를 창조할 열정 넘치는
          인재를 기다립니다.
        </div>
      </div>
    </div>
    <!--// sub title -->
    <!-- sub contents -->
    <div :class="['sub_contents', { bg_gray: isPC }]">
      <!-- 채용안내 -->
      <div :class="[{ inner2: isPC }]">
        <h3 v-if="isPC">채용프로세스</h3>
        <div class="recurit_info">
          <ol class="order_info">
            <li>
              01
              <p>서류전형</p>
            </li>
            <li>
              02
              <p>면접전형<br />(1차, 2차)</p>
            </li>
            <li>
              03
              <p>채용검진</p>
            </li>
            <li>
              04
              <p>최종합격</p>
            </li>
          </ol>
          <ol class="order_li">
            <li>
              <dl>
                <dt>01<strong>서류전형</strong></dt>
                <dd>
                  <ul class="order_detail">
                    <li>
                      입사지원서 내용을 바탕으로 지원자가 지원한 직무에 적합한
                      인재인지 검토합니다.
                    </li>
                    <li>
                      지원한 직무를 수행하는데 필요한 역량을 갖추었는지, 회사의
                      인재상에 부합한 인재인지 종합적으로 평가합니다.
                    </li>
                  </ul>
                </dd>
              </dl>
            </li>
            <li>
              <dl>
                <dt>02<strong>면접전형</strong></dt>
                <dd>
                  <ul class="order_detail">
                    <li>
                      지원자의 업무수행능력, 잠재력, 열정, 인성 등을 종합적으로
                      평가합니다.
                    </li>
                    <li>
                      지원자의 실무역량을 평가하고, 지원자가 한국오션플랫폼에
                      융합될 수 있는 인재인지 평가합니다.
                    </li>
                  </ul>
                </dd>
              </dl>
            </li>
            <li>
              <dl>
                <dt>03<strong>채용검진</strong></dt>
                <dd>
                  <ul class="order_detail">
                    <li>
                      업무를 수행하는데 신체적인 무리가 없는지 검진병원에서
                      채용검진을 진행합니다.
                    </li>
                  </ul>
                </dd>
              </dl>
            </li>
            <li>
              <dl>
                <dt>04<strong>최종합격</strong></dt>
                <dd>
                  <ul class="order_detail">
                    <li>
                      입사 여부를 확정하면 한국오션플랫폼의 가족으로 입사하는
                      동시에 교육을 받습니다.
                    </li>
                  </ul>
                </dd>
              </dl>
            </li>
            <li v-if="isPC">
              <p>
                채용관련 문의사항 - Tel : 031-5171-0718 / E-mail :
                <a href="mailto:insa@kop.co.kr">insa@kop.co.kr</a>
              </p>
            </li>
            <li class="order_inq" v-else>
              <ul class="order_detail">
                <li>채용관련 문의사항</li>
              </ul>
              <ul class="order_dash">
                <li>Tel : 031-5171-0718</li>
                <li>
                  E-mail :
                  <a href="mailto:insa@hkop.co.kr">insa@kop.co.kr</a>
                </li>
              </ul>
            </li>
          </ol>
          <div class="btn_cnt_wrap" v-if="ypRecuruit !== '#'">
            <a
              :href="ypRecuruit"
              target="_blank"
              rel="noreferrer noopener"
              class="btn_blue"
              >입사지원 바로가기</a
            >
          </div>
        </div>
      </div>
      <!-- //채용안내 -->

      <h3 v-if="!isPC">RECRUT FAQ</h3>

      <!-- toggle -->
      <faq-list v-if="!isPC" />
      <!--// toggle -->
    </div>
    <div class="sub_contents" v-if="isPC">
      <h3>RECRUT FAQ</h3>

      <!-- toggle -->
      <faq-list />
      <!--// toggle -->
    </div>
    <!--// sub contents -->
  </div>
  <!--// container -->
</template>

<script>
import page from '@/mixins/page';
import { head, get } from 'lodash-es';

import FaqList from './_FaqList';

/**
 * @module pages/recruit/p_recruit028
 * @desc 인재채용 > 채용안내
 * @vue-data {Boolean} recruitInfo=null - 입사지원 바로가기 버튼의 상태 값
 * @vue-computed {String} ypRecuruit - 현재 스크롤
 * @vue-computed {Boolean} isPC - PC 체크
 */
export default {
  components: {
    FaqList
  },
  mixins: [page],
  data() {
    return {
      recruitInfo: null
    };
  },
  computed: {
    ypRecuruit() {
      return get(head(this.recruitInfo), 'url', '#');
    },
    isPC() {
      return this.device === 'pc';
    }
  },
  mounted() {
    this.showRecruit();
  },
  methods: {
    /**
     * 입사지원 바로가기 버튼 상태 값 체크 후 업데이트
     */
    showRecruit() {
      this.axios
        .get('/api/getRecruits.do')
        .then((res) => {
          if (res.data.status === 'N') {
            return;
          }

          this.recruitInfo = get(res, 'data.item').filter(
            (item) => item.use_yn === 'Y'
          );
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
